<template>
  <div class="page-content-wrapper" v-check-permission="'edit-users'">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="card m-b-20">
            <div class="card-block">
              <h4 class="mt-0 header-title">Usuario</h4>
              <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>
              <div class="alert alert-success p-3" role="alert" v-if="savedSuccessfully">Los datos se han guardado.</div>
              <template v-if="user">
                <div class="form-group" v-bind:class="{ 'has-danger': $v.user.email.$error }">
                  <label>Email</label>
                  <input type="email" class="form-control" v-model="user.email" @input="$v.user.email.$touch()">
                  <div class="form-control-feedback" v-if="!$v.user.email.required && $v.user.email.$error">El email es requerido.</div>
                  <div class="form-control-feedback" v-if="!$v.user.email.email && $v.user.email.$error">Ingrese un email válido.</div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-danger': $v.user.password.$error }">
                  <label>Contraseña</label>
                  <input type="password" class="form-control" v-model="user.password"  @input="$v.user.password.$touch()">
                  <div class="form-control-feedback" v-if="!$v.user.password.minLength && $v.user.password.$error">La contraseña debe tener al menos {{ $v.user.password.$params.minLength.min }} caracteres.</div>
                  <small class="form-text text-muted">Ingrese una contraseña, solo si desea cambiar la anterior.</small>
                </div>
                <div class="form-group">
                  <label>Nombre para mostrar</label>
                  <input type="text" class="form-control" v-model="user.displayName">
                </div>
                <div class="form-group" v-if="currentUser.admin">
                  <label>Establecer como Administrador</label>
                  <div>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="user.admin">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">Si</span>
                    </label>
                  </div>
                </div>
                <div class="form-group" v-if="!user.admin && currentUser.admin">
                  <label>Seleccionar el Rol</label>
                  <select class="custom-select" v-model="user.role">
                    <option v-for="role in roles" v-bind:value="role._id">
                      {{ role.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group  m-b-0">
                  <label>Estado</label>
                  <div>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="user.active">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">Activo</span>
                    </label>
                  </div>
                </div>
                <div class="card-block pull-right pr-0">
                  <div class="loading waves-effect mr-2" v-if="isSaving">
                      <i class="fa fa-spin fa-circle-o-notch"></i>
                  </div>
                  <router-link to="/users" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, minLength, email } from 'vuelidate/lib/validators'

  export default {
    name: 'edit-user',
    created () {
      this.getUser()
    },
    data () {
      return {
        error: '',
        isSaving: false,
        savedSuccessfully: false,
        currentUser: this.$store.state.auth.user
      }
    },
    computed: {
      user: function () {
        return this.$store.getters.getUser
      },
      roles: function () {
        return this.$store.getters.getAllRoles
      }
    },
    validations: {
      user: {
        email: {
          required,
          email
        },
        password: {
          minLength: minLength(6)
        }
      }
    },
    methods: {
      submit: function () {
        this.$v.user.$touch()

        if(!this.$v.user.$error) {
          this.isSaving = true
          $('.save-btn').attr('disabled', true)

          this.$store.dispatch('editUser', {user: this.user})
            .then((response) => {
              this.isSaving = false
              this.savedSuccessfully = true
              const self = this
              setTimeout(function () {
                self.$router.push('/users')
              }, 500)

              $('.save-btn').attr('disabled', false)
            })
            .catch((response) => {
              this.isSaving = false
              this.error = response.message
              $('.save-btn').attr('disabled', false)
            })
        }
      },
      getUser: function () {
        this.$store.dispatch('getUser', { id : this.$route.params.id })
          .then((response) => {
            this.isSaving = false
            this.getAllRoles()
          })
          .catch(error => {
            this.error = error
            this.isSaving = false
          })
      },
      getAllRoles () {
        this.$store.dispatch('getAllRoles')
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/screens/EditUserScreen.vue